import { Component, OnInit } from '@angular/core'
import { collection, collectionData, orderBy, query } from '@angular/fire/firestore'
import { AdminService } from '../../../services/admin.service'
import { Blog, blogsPath } from '@parkupp/core'
import { Router } from '@angular/router'
import { GlobalService } from '../../../services/global.service'

@Component({
    selector: 'app-news-page',
    templateUrl: './blog-list-page.component.html',
    styleUrls: ['./blog-list-page.component.scss'],
})
export class BlogListPageComponent implements OnInit {
    GlobalService = GlobalService
    blogs: Blog[]

    constructor(private adminService: AdminService, private router: Router) {
        console.log('hello')

        const ref = query(collection(this.adminService.firestore, blogsPath()), orderBy('createdAt', 'desc'))
        collectionData(ref, { idField: 'documentId' }).subscribe((documents: any[]) => {
            this.blogs = []
            documents.forEach((documentData) => {
                let blog = new Blog(documentData)
                blog.$key = documentData.documentId
                if (blog.title) {
                    this.blogs.push(blog)
                }
            })
            console.log(this.blogs)
        })
    }

    ngOnInit(): void {}

    goToBlogPage(blog: Blog) {
        if (blog.link) {
            document.location.href = blog.link
            // window.open(blog.link, '_blank')
        } else {
            this.router.navigate([`blog/${blog.$key}`])
        }
    }
}
